import { createTimerHook, type TimerState, type TimerHookReturn } from "../../../shared/hooks/create-timer-hook";
import { getTimerSettings } from "../../settings/hooks/use-timer-settings";
import { playSound } from "../../settings/utils/sound-presets";
import { TWENTY_MODES, type TwentyMode } from "../../settings/types/timer-settings";

export type TwentyState = TimerState<TwentyMode>;

export interface UseTwentyReturn extends TimerHookReturn<TwentyMode> {
  readonly state: TwentyState;
}

export const useTwenty = createTimerHook<TwentyMode>({
  storageKey: "palnia_twenty",
  serverKey: "twenty",
  legacyCounterKey: "cyclesCompleted",
  validModes: TWENTY_MODES,
  defaultMode: "screen",
  getDefaultDuration: () => getTimerSettings().twenty.screenDuration * 60,

  getTransition: (prev) => {
    const s = getTimerSettings().twenty;
    if (prev.mode === "screen") {
      return { mode: "break", timeLeft: s.breakDuration, counter: prev.counter };
    }
    return { mode: "screen", timeLeft: s.screenDuration * 60, counter: prev.counter + 1 };
  },

  getAutoStart: (fromSkip) => {
    const s = getTimerSettings().twenty;
    return fromSkip ? s.autoStartOnSkip : s.autoStart;
  },

  onTransitionSound: () => {
    playSound(getTimerSettings().twenty.transitionSound);
  },

  getNotificationMessage: (endedMode) => {
    if (endedMode === "screen") return "Pause yeux — regardez au loin pendant 20 secondes";
    return "Pause terminée — retour à l'écran";
  },
});
